import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { AppCommonsModule } from "src/app/commons/app-commons.module";
import { PlessSharedModule } from "src/app/shared/pless-shared.module";
import { KYMW6902Module } from "../kymw6902/kymw6902.module";
import { KYMW6901MasterInputTabModule } from "./kymw6901-master-input-tab/kymw6901-master-input-tab.module";
import { KYMW6901ProposalTabModule } from "./kymw6901-proposal-tab/kymw6901-proposal-tab.module";
import { KYMW6901Component } from "./kymw6901.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WjNavModule,
    AppCommonsModule,
    PlessSharedModule,
    KYMW6901ProposalTabModule,
    KYMW6901MasterInputTabModule,
    KYMW6902Module
  ],
  declarations: [
    KYMW6901Component,
  ],
})

export class KYMW6901Module { }